/*(function ($) {
  $(function () {
    $(window).on('scroll load', function () {
      if ($(this).scrollTop() > $(document).height() * 0.1) {
        $('#scroll_to_top').addClass('active');
      } else {
        $('#scroll_to_top').removeClass('active');
      }
    });

    $('#scroll_to_top').on('click', function () {
      $('html, body').animate({scrollTop: 0}, 700);
    })
  });
})(jQuery);*/

(function ($) {
function scroll_to_top(){
	var btn = document.getElementById('scroll_to_top');
	const whatsapp_btn = document.getElementById('footer_whatsapp_button');
	if(!btn) return;

	var methods = {
		click: function(){
			$("html, body").stop().animate({scrollTop:0}, 700, 'linear');
		},
		appear: function(e){
			if(window.pageYOffset > jQuery(window).height()){
				if(btn.className.indexOf('active') === -1){
					btn.className += " active";
				}
				if(whatsapp_btn && !whatsapp_btn.classList.contains('scrolldown')){
					whatsapp_btn.classList.add("scrolldown");
				}
			} else {
				btn.className = btn.className.replace(' active','');
				if(whatsapp_btn){
					whatsapp_btn.classList.remove('scrolldown');
				}
			}
		}
	};
	btn.addEventListener('click',methods.click);
	window.addEventListener('scroll',function(e){
		methods.appear(e);
	});
}
window.addEventListener('load', function(){
	scroll_to_top();
});	
})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/scroll-top.js